import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56VComponentiEf({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v-componenti-ef" w={65.617} h={65.619} className={className}>
      <g transform="translate(-38 -39.112)">
        <g>
          <defs>
            <rect
              id={`batteria56vcomponentief_${idVariant}_SVGID_1_`}
              x="38"
              y="39.112"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56vcomponentief_${idVariant}_SVGID_2_`}>
            <use xlinkHref={`#batteria56vcomponentief_${idVariant}_SVGID_1_`} overflow="visible" />
          </clipPath>
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M71.587,104.73c17.69,0,32.03-14.34,32.03-32.031
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C39.558,90.391,53.897,104.73,71.587,104.73"
          />
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M70.03,103.174c17.691,0,32.031-14.342,32.031-32.031
      		c0-17.69-14.34-32.031-32.031-32.031C52.34,39.112,38,53.453,38,71.143C38,88.832,52.34,103.174,70.03,103.174"
          />
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M59.184,66.733c3.64,0.008,6.587-2.917,6.603-6.552
      		c0.017-3.643-2.961-6.64-6.589-6.633c-3.601,0.008-6.59,2.996-6.593,6.594C52.601,63.751,55.57,66.726,59.184,66.733
      		 M61.438,44.764v4.614c2.354,0.517,4.319,1.703,5.969,3.512c1.337-0.766,2.668-1.528,4.042-2.316
      		c0.739,1.276,1.456,2.516,2.196,3.795c-1.195,0.689-2.337,1.38-3.511,2.012c-0.431,0.232-0.513,0.447-0.365,0.912
      		c0.606,1.901,0.585,3.815,0.012,5.726c-0.054,0.18-0.103,0.359-0.166,0.582c1.338,0.775,2.668,1.545,4.028,2.333
      		c-0.739,1.278-1.457,2.521-2.194,3.795c-1.358-0.779-2.677-1.538-4.037-2.319c-0.228,0.231-0.449,0.467-0.681,0.688
      		c-1.395,1.331-3.017,2.259-4.893,2.714c-0.34,0.082-0.437,0.218-0.432,0.55c0.017,1.184,0.006,2.37,0.006,3.555v0.59h-4.387v-4.572
      		c-2.391-0.526-4.375-1.715-6.019-3.523c-1.35,0.774-2.682,1.539-4.043,2.319c-0.74-1.279-1.458-2.522-2.194-3.797
      		c1.239-0.715,2.434-1.422,3.647-2.093c0.325-0.18,0.375-0.344,0.263-0.688c-0.647-2.005-0.647-4.02,0.006-6.021
      		c0.119-0.365,0.019-0.509-0.285-0.679c-1.197-0.668-2.379-1.363-3.63-2.085c0.728-1.263,1.442-2.501,2.191-3.798
      		c1.358,0.777,2.689,1.541,4.044,2.317c1.635-1.794,3.609-2.999,6.003-3.512v-4.612H61.438z"
          />
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M74.602,82.133c0.002,3.617,2.963,6.588,6.574,6.598
      		c3.595,0.01,6.59-2.973,6.608-6.578c0.019-3.625-2.978-6.617-6.616-6.607C77.535,75.557,74.6,78.5,74.602,82.133 M78.952,97.516
      		v-4.611c-2.382-0.523-4.36-1.719-5.989-3.516c-1.351,0.775-2.669,1.533-4.042,2.32c-0.735-1.27-1.451-2.508-2.195-3.793
      		c0.952-0.551,1.867-1.08,2.78-1.611c0.399-0.232,0.964-0.391,1.134-0.738c0.151-0.309-0.141-0.834-0.237-1.264
      		c-0.394-1.748-0.319-3.477,0.233-5.178c0.113-0.352,0.049-0.51-0.27-0.688c-1.211-0.674-2.405-1.379-3.64-2.092
      		c0.739-1.279,1.457-2.521,2.194-3.797c1.357,0.779,2.678,1.539,4,2.297c0.529-0.471,1.032-0.961,1.577-1.398
      		c1.192-0.961,2.541-1.626,4.03-1.978c0.376-0.088,0.443-0.25,0.439-0.591c-0.018-1.354-0.008-2.709-0.008-4.104h4.409v1.266
      		c0,0.979-0.012,1.957,0.013,2.935c0.004,0.154,0.148,0.41,0.271,0.439c2.259,0.542,4.125,1.728,5.716,3.457
      		c1.338-0.77,2.669-1.533,4.039-2.32c0.736,1.273,1.453,2.514,2.193,3.795c-1.157,0.67-2.268,1.352-3.414,1.959
      		c-0.5,0.266-0.611,0.512-0.436,1.066c0.603,1.9,0.559,3.824-0.052,5.719c-0.131,0.406-0.024,0.574,0.312,0.76
      		c1.183,0.66,2.351,1.344,3.592,2.057c-0.727,1.262-1.441,2.5-2.192,3.801c-1.353-0.775-2.681-1.537-4.041-2.316
      		c-1.635,1.787-3.606,2.996-5.985,3.508v4.617H78.952z"
          />
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M59.185,66.734c-3.614-0.007-6.584-2.982-6.58-6.591
      		c0.004-3.599,2.992-6.587,6.593-6.595c3.629-0.007,6.606,2.989,6.59,6.632C65.771,63.817,62.824,66.741,59.185,66.734"
          />
          <path
            clipPath={`url(#batteria56vcomponentief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M74.602,82.133c-0.001-3.633,2.934-6.576,6.566-6.588
      		c3.64-0.01,6.635,2.982,6.617,6.607c-0.02,3.605-3.016,6.588-6.609,6.578C77.564,88.721,74.603,85.75,74.602,82.133"
          />
        </g>
      </g>
    </IconBase>
  )
}

export default Batteria56VComponentiEf
